import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from 'shared/actions/authentication';
import { openChat } from 'shared/actions/chat';
import { NotAvailablePopup } from 'shared/components/NotAvailablePopup';
import { offerDataSelector, selectIsAuthenticated } from 'shared/selectors';
import { selectNotAvailablePopupOpen } from 'shared/selectors/selectNotAvailablePopupOpen';
import { setNotAvailablePopupOpenValue } from 'shared/store/notAvailablePopupOpen';

import { trackCallAnyway, trackPopupShown, trackWriteMessageClick } from './tracking';

export const NotAvailablePopupContainer: React.VFC = () => {
  const dispatch = useDispatch();
  const { agentAvailability, offer, agent } = useSelector(offerDataSelector);
  const isNotAvailablePopupOpened = useSelector(selectNotAvailablePopupOpen);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const onWriteMessage = React.useCallback(() => {
    trackWriteMessageClick(offer, agent);
    dispatch(setNotAvailablePopupOpenValue(false));

    if (!isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => openChat('open_message'),
          alert: EAlertType.Chats,
        }),
      );

      return;
    }

    dispatch(openChat('open_message'));
  }, [offer, agent, dispatch, isAuthenticated]);

  const onCallAnyway = React.useCallback(() => {
    trackCallAnyway(offer, agent);
    dispatch(setNotAvailablePopupOpenValue(false));
  }, [offer, agent, dispatch]);

  const onClose = React.useCallback(() => {
    dispatch(setNotAvailablePopupOpenValue(false));
  }, [dispatch]);

  const onShow = React.useCallback(() => trackPopupShown(offer, agent), [offer, agent]);

  if (!isNotAvailablePopupOpened || !agentAvailability || agentAvailability.available) {
    return null;
  }

  const { title, message } = agentAvailability;

  return (
    <NotAvailablePopup
      onClose={onClose}
      onCallAnyway={onCallAnyway}
      onWriteMessage={onWriteMessage}
      onShow={onShow}
      title={title || ''}
      message={message || ''}
    />
  );
};
